<template>
    <div class="col-lg-8 col-xlg-9 col-md-7">
        <div class="card">
            <div class="card-header">
                <h4 class="card-title"><i class="far fa-building"></i> Account Settings</h4>
                <h6 class="card-subtitle">Please keep your profile information always current in order to help you when you contact us.</h6>
            </div>
            <form class="form-horizontal" @submit.prevent="handleAccountSubmit">
                <div class="card-body card-blue">
                    <div class="form-group row">
                        <label for="account_name" class="col-sm-3 text-right control-label col-form-label">Account Name</label>
                        <div class="col-sm-9">
                            <input type="text" class="form-control" id="account_name" v-model="org.name" placeholder="Account Name">
                        </div>
                    </div>
                    <div class="form-group row">
                        <label for="account_description" class="col-sm-3 text-right control-label col-form-label">Account Description</label>
                        <div class="col-sm-9">
                            <textarea type="text" class="form-control" id="account_description" v-model="org.description" rows=7
                                      placeholder="Account Description" required>
                            </textarea>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label for="line1" class="col-sm-3 text-right control-label col-form-label">Address</label>
                        <div class="col-sm-5">
                            <input type="text" class="form-control" id="line1" v-model="org.line1" placeholder="Address Line 1">
                        </div>
                    </div>
                    <div class="form-group row">
                        <label for="line2" class="col-sm-3 text-right control-label col-form-label"></label>
                        <div class="col-sm-5">
                            <input type="text" class="form-control" id="line2" v-model="org.line2" placeholder="Address Line 2">
                        </div>
                    </div>
                    <div class="form-group row">
                        <label for="city" class="col-sm-3 text-right control-label col-form-label"></label>
                        <div class="col-sm-5">
                            <input type="text" class="form-control" id="city" v-model="org.city" placeholder="City">
                        </div>
                    </div>
                    <div class="form-group row">
                        <label for="state" class="col-sm-3 text-right control-label col-form-label"></label>
                        <div class="col-sm-5">
                            <input type="text" class="form-control" id="state" v-model="org.state" placeholder="State">
                        </div>
                    </div>
                    <div class="form-group row">
                        <label for="postal_code" class="col-sm-3 text-right control-label col-form-label"></label>
                        <div class="col-sm-5">
                            <input type="text" class="form-control" id="postal_code" v-model="org.postal_code" placeholder="Postal Code">
                        </div>
                    </div>
                    <div class="form-group row">
                        <label for="country" class="col-sm-3 text-right control-label col-form-label"></label>
                        <div class="col-sm-5">
                            <input type="text" class="form-control" id="country" v-model="org.country" placeholder="Country">
                        </div>
                    </div>
                    <div class="form-group row">
                        <label for="account_name" class="col-sm-3 text-right control-label col-form-label">DID</label>
                        <div class="col-sm-9">
                            <input type="text" class="form-control" id="account_name" v-model="org.did" placeholder="DID">
                        </div>
                    </div>
                    <div class="form-group row">
                        <label for="account_name" class="col-sm-3 text-right control-label col-form-label">Audit</label>
                        <div class="col-sm-9">
                            <input type="text" class="form-control" id="account_name" v-model="org.audit" placeholder="Audit">
                        </div>
                    </div>
                     <div class="form-group row">
                        <label for="line1" class="col-sm-3 text-right control-label col-form-label">Bank</label>
                        <div class="col-sm-9">
                            <input type="text" class="form-control" id="line1" v-model="org.bank.name" placeholder="Name">
                        </div>
                    </div>
                    <div class="form-group row">
                        <label for="line1" class="col-sm-3 text-right control-label col-form-label"></label>
                        <div class="col-sm-9">
                            <textarea type="text" class="form-control" id="account_description" v-model="org.bank.address" rows=7
                                      placeholder="Bank Address" required>
                            </textarea>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label for="line1" class="col-sm-3 text-right control-label col-form-label"></label>
                        <div class="col-sm-5">
                            <input type="text" class="form-control" id="line1" v-model="org.bank.ac" placeholder="Account Number">
                        </div>
                    </div>
                    <div class="form-group row">
                        <label for="line1" class="col-sm-3 text-right control-label col-form-label"></label>
                        <div class="col-sm-5">
                            <input type="text" class="form-control" id="line1" v-model="org.bank.ifsc" placeholder="IFSC Code">
                        </div>
                    </div>
                    <div class="form-group row">
                        <label for="line1" class="col-sm-3 text-right control-label col-form-label"></label>
                        <div class="col-sm-5">
                            <input type="text" class="form-control" id="line1" v-model="org.bank.swift" placeholder="Swift Code">
                        </div>
                    </div>
                    <div class="form-group row">
                        <label for="line1" class="col-sm-3 text-right control-label col-form-label"></label>
                        <div class="col-sm-5">
                            <input type="text" class="form-control" id="line1" v-model="org.bank.micr" placeholder="MICR Code">
                        </div>
                    </div>
                </div>
                <div class="card-footer">
                    <div class="form-group m-b-0 text-right">
                        <div class="button-group">
                            <button type="submit" class="btn waves-effect waves-light btn-success">Save</button>
                            <button type="button" @click="resetAccount()" class="btn waves-effect waves-light btn-secondary">Reset</button>
                        </div>
                    </div>
                </div>
            </form>
        </div>

        <div class="card">
            <div class="card-header">
                <h4 class="card-title">Public Information</h4>
                <h6 class="card-subtitle">This information helps customers recognize your business and may be visible in many places including card statements, invoices, and receipts.</h6>
            </div>
            <form class="form-horizontal">
                <div class="card-body card-blue">
                    <div class="form-group row">
                        <label for="biz_name" class="col-sm-3 text-right control-label col-form-label">Leagl Business Name</label>
                        <div class="col-sm-9">
                            <input type="text" class="form-control" id="biz_name" v-model="org.biz_name" placeholder="Legal Business Name">
                        </div>
                    </div>
                    <div class="form-group row">
                        <label for="biz_phone" class="col-sm-3 text-right control-label col-form-label">Phone</label>
                        <div class="col-sm-5">
                            <input type="text" class="form-control" id="biz_phone" v-model="org.biz_phone" placeholder="Business Phone">
                        </div>
                    </div>
                    <div class="form-group row">
                        <label for="biz_email" class="col-sm-3 text-right control-label col-form-label">Email</label>
                        <div class="col-sm-5">
                            <input type="text" class="form-control" id="biz_email" v-model="org.biz_email" placeholder="Business Email">
                        </div>
                    </div>
                    <div class="form-group row">
                        <label for="biz_web" class="col-sm-3 text-right control-label col-form-label">Website</label>
                        <div class="col-sm-5">
                            <input type="text" class="form-control" id="biz_web" v-model="org.biz_web" placeholder="Business Website">
                        </div>
                    </div>
                    <div class="form-group row">
                        <label for="biz_line1" class="col-sm-3 text-right control-label col-form-label">Business Address</label>
                        <div class="col-sm-5">
                            <input type="text" class="form-control" id="biz_line1" v-model="org.biz_line1" placeholder="Address Line 1">
                        </div>
                    </div>
                    <div class="form-group row">
                        <label for="biz_line2" class="col-sm-3 text-right control-label col-form-label"></label>
                        <div class="col-sm-5">
                            <input type="text" class="form-control" id="biz_line2" v-model="org.biz_line2" placeholder="Address Line 2">
                        </div>
                    </div>
                    <div class="form-group row">
                        <label for="biz_city" class="col-sm-3 text-right control-label col-form-label"></label>
                        <div class="col-sm-5">
                            <input type="text" class="form-control" id="biz_city" v-model="org.biz_city" placeholder="City">
                        </div>
                    </div>
                    <div class="form-group row">
                        <label for="biz_state" class="col-sm-3 text-right control-label col-form-label"></label>
                        <div class="col-sm-5">
                            <input type="text" class="form-control" id="biz_state" v-model="org.biz_state" placeholder="State">
                        </div>
                    </div>
                    <div class="form-group row">
                        <label for="biz_postal_code" class="col-sm-3 text-right control-label col-form-label"></label>
                        <div class="col-sm-5">
                            <input type="text" class="form-control" id="biz_postal_code" v-model="org.biz_postal_code" placeholder="Postal Code">
                        </div>
                    </div>
                    <div class="form-group row">
                        <label for="biz_country" class="col-sm-3 text-right control-label col-form-label"></label>
                        <div class="col-sm-5">
                            <input type="text" class="form-control" id="biz_country" v-model="org.biz_country" placeholder="Country">
                        </div>
                    </div>

                </div>
                <div class="card-footer">
                    <div class="form-group m-b-0 text-right">
                        <div class="button-group">
                            <button type="button" class="btn waves-effect waves-light btn-success">Save</button>
                            <button type="button" @click="reset()" class="btn waves-effect waves-light btn-secondary">Reset</button>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>

</template>

<script>
    import {mapGetters} from "vuex";

    export default {
        name: "ViewProfile",
        computed: {
            ...mapGetters(["currentUser", "currentOrg"])
        },
        data() {
            return {
                org: {
                    biz_city: "",
                    biz_country: "",
                    biz_email: "",
                    biz_line1: "",
                    biz_line2: "",
                    biz_name: "",
                    biz_phone: "",
                    biz_postal_code: "",
                    biz_state: "",
                    biz_web: "",
                    city: "",
                    country: "",
                    description: "",
                    id: 0,
                    line1: "",
                    line2: "",
                    name: "",
                    postal_code: "",
                    state: "",
                    type: "",
                    did: null,
                    audit: null,
                    bank: {
                        name: null,
                        address: null,
                        ac: null,
                        ifsc: null,
                        swift: null,
                        micr: null
                    }
                },
                bkp: null,
            };
        },
        mounted() {
            this.getOrg();
        },
        methods: {
            async getOrg() {
                $(".preloader").fadeIn();
                let reply = await this.$http.get("/org/" + this.currentOrg.id + "/profile");
                this.bkp  = {...reply.data};
                if(!this.bkp.bank){
                    this.bkp.bank = {
                        name: null,
                        address: null,
                        ac: null,
                        ifsc: null,
                        swift: null,
                        micr: null
                    }
                }
                this.org  = {...this.bkp};
            
                $(".preloader").fadeOut();
            },
            resetAccount(){
                this.org = {...this.bkp};
            },
            async handleAccountSubmit(){
                $(".preloader").fadeIn();
                await this.$http.put("/org/" + this.currentOrg.id + "/profile", this.org);
                $(".preloader").fadeOut();
                await this.getOrg();
            }
        }
    }
</script>

<style scoped>

</style>
